module.exports = __webpack_public_path__ + "img/7.6887ff05.svg";